<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { imageAdditionalDetails } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="imageAdditionalDetails.display" class="col-span-12">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ imageAdditionalDetails.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsImages
          :images="details.imageAdditionalDetails"
          with-labels
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
